import { render } from "./office-list.vue?vue&type=template&id=a90a060c"
import script from "./office-list.vue?vue&type=script&lang=js"
export * from "./office-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__